import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import css from "./assets/css/style.css";
import * as api from "./api/client";
import * as utils from "./utils";
import * as constants from "./constants";

Vue.config.productionTip = false;

/*-- 2026.07.18 V2.2 AI MOD START --*/
// Vue.prototype.$version = "2.1.1.3";
Vue.prototype.$version = "2.2.0";
/*-- 2026.07.18 V2.2 AI MOD END --*/

Vue.use({
  install(Vue) {
    Vue.prototype.$axios = axios.create({
      baseURL: `${process.env.VUE_APP_API_ORIGIN}/`,
    });
    /*-- 2026.09.08 V2.2.1 AI ADD START チケット#14484 全API認証導入フェーズ1、トークン送信対応
         （サーバー側はまだ検証を強制しない緩い状態） --*/
    Vue.prototype.$axios.interceptors.request.use(function (config) {
      const token = store.state.token;
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
    /*-- 2026.09.08 V2.2.1 AI ADD END --*/
    /*-- 2026.09.08 V2.2.1 AI ADD START チケット#14484 フェーズ3（トークン必須化）でサーバーが401を
         返すようになった際、利用者に生のエラーを見せず自動的にログアウト・ログイン画面へ戻す。
         現時点ではどのルートもトークンを検証していないため401は返らず、実質的にまだ発火しない --*/
    Vue.prototype.$axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        if (error.response && error.response.status === 401) {
          /*-- 2026.09.10 V2.2.1 AI MOD START チケット#14484 何も表示せずいきなりログイン画面に
               戻ると利用者が状況を理解できないため、リダイレクト前にメッセージを表示するよう修正 --*/
          if (router.app && router.app.snackbar) {
            router.app.snackbar.showMessage("セッションの有効期限が切れました。再度ログインしてください。", "warning");
          }
          /*-- 2026.09.10 V2.2.1 AI MOD END --*/
          const kigyoCd = store.state.kigyoCode;
          store.commit("reset");
          router.push({ name: "UserLogin", params: { kigyoCd } }).catch(() => {});
        }
        return Promise.reject(error);
      }
    );
    /*-- 2026.09.08 V2.2.1 AI ADD END --*/
    Vue.prototype.$api = api;
    Vue.prototype.$utils = utils;
    Vue.prototype.$constants = constants;
  },
});

new Vue({
  router,
  store,
  vuetify,
  css,
  render: (h) => h(App),
}).$mount("#app");
